export const DEFAULT_MAX_BODY_CHAR_COUNT = 250